module.exports = {"540231100":"江嘎镇","540231101":"陈塘镇","540231102":"日屋镇","540231201":"确布乡","540231202":"定结乡","540231203":"多布扎乡","540231204":"扎西岗乡","540231205":"琼孜乡","540231206":"萨尔乡","540231207":"郭加乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540231.json
// module id = 2834
// module chunks = 0